export const categories = [
  {
    id: "events",
    name: "事件全记录",
    desc: "把一件事从头到尾理成一条线，不遗漏关键节点。",
    icon: "ri-file-list-3-line",
  },
  {
    id: "dialogues",
    name: "对话实录",
    desc: "复原双方往来信息，保留原始语气与前后语境。",
    icon: "ri-chat-3-line",
  },
  {
    id: "opinion",
    name: "舆论观察",
    desc: "记录情绪曲线的起伏，拆解话题被放大的方式。",
    icon: "ri-line-chart-line",
  },
  {
    id: "pr",
    name: "公关复盘",
    desc: "从预热到致歉，看回应节奏如何影响事件走向。",
    icon: "ri-megaphone-line",
  },
  {
    id: "fandom",
    name: "粉丝生态",
    desc: "应援、控评与决策讨论的现场，还原社群内部逻辑。",
    icon: "ri-group-line",
  },
  {
    id: "industry",
    name: "行业透视",
    desc: "演出、综录、剧集宣发背后的流程与规则拆解。",
    icon: "ri-building-2-line",
  },
];

export const topics = [
  {
    id: "t1",
    slug: "variety-lyric-dispute",
    title: "综艺改词风波：一档音乐综艺的现场对话全整理",
    category: "events",
    summary:
      "一段被剪掉的彩排在节目播出后重新流传开来。我们把现场沟通、导演组反馈与选手回应的全部文字片段按时间顺序拼回，还原这次「改词」到底是临时起意还是既定流程。",
    date: "2026-08-14",
    readTime: "12 分钟",
    views: "8.6 万",
    tags: ["综艺", "改词", "现场", "剪辑"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20an%20empty%20music%20studio%20booth%20with%20a%20vintage%20condenser%20microphone%20and%20warm%20amber%20spotlight%2C%20cream%20paper%20tones%20with%20vermillion%20accents%2C%20soft%20grain%2C%20calm%20harmonious%20composition%2C%20clean%20minimal%20background&width=1200&height=800&seq=hc-cover-01&orientation=landscape",
    hot: true,
    timeline: [
      { time: "D-3 14:20", text: "彩排首次调整歌词，导演组口头说明「上线版本以播出为准」。" },
      { time: "D-2 09:05", text: "选手在群内确认新词版本，并要求保留原词作为备注。" },
      { time: "D-1 21:40", text: "录制当日临时通知再改一处用词，现场未留下书面记录。" },
      { time: "播出当晚 20:00", text: "节目上线，相关片段被剪去，引发讨论。" },
      { time: "次日 10:30", text: "现场音频流出，舆论转向对「流程」的质疑。" },
    ],
    dialogues: [
      { speaker: "导演组", side: "left", text: "这一段的词再调整一下，播出效果会更好，观众不容易出戏。" },
      { speaker: "选手", side: "right", text: "可以改，但希望保留一个原词版本，方便对稿。" },
      { speaker: "导演组", side: "left", text: "没问题，录制前我们会把最终版发到群里。" },
      { speaker: "选手", side: "right", text: "那如果最后没发，是不是就按彩排这版走？" },
      { speaker: "导演组", side: "left", text: "以群里最终通知为准，你先按现在这版练。" },
    ],
    responses: [
      {
        party: "节目组",
        content: "回应称改词属于常规调整，出于播出效果与节奏考虑，并未针对个人，后续会优化通知流程。",
      },
      {
        party: "选手团队",
        content: "表示理解节目制作需要，但希望重要调整能有书面确认，避免沟通偏差。",
      },
      {
        party: "观众代表",
        content: "关注点主要集中在「是否有最终确认环节」，而非改词本身。",
      },
    ],
    notes: [
      "事件的核心矛盾并不在改词，而在「口头约定 vs 书面确认」的流程缺口。",
      "录制型节目普遍存在临场调整，观众真正在意的信息透明度。",
      "当现场素材成为二次传播的源头，任何被剪掉的部分都可能重新进入讨论。",
    ],
  },
  {
    id: "t2",
    slug: "livestream-collapse-chain",
    title: "直播翻车事件：从选品到致歉的完整对话链条",
    category: "events",
    summary:
      "一场时长四小时的直播，在第二小时出现商品描述偏差。我们按分钟整理主播、场控与商家的沟通记录，呈现一次直播事故是如何被逐步放大的。",
    date: "2026-08-09",
    readTime: "15 分钟",
    views: "12.4 万",
    tags: ["直播", "选品", "危机处理"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20an%20empty%20livestream%20studio%20desk%20with%20a%20ring%20light%20and%20product%20boxes%20neatly%20arranged%2C%20warm%20cream%20backdrop%20with%20muted%20vermillion%20highlights%2C%20soft%20shadows%2C%20clean%20minimal%20composition%2C%20calm%20neutral%20tone&width=1200&height=800&seq=hc-cover-02&orientation=landscape",
    hot: true,
    timeline: [
      { time: "19:00", text: "直播开播，第一小时节奏正常，商品讲解按脚本进行。" },
      { time: "20:12", text: "讲解第二款商品时，主播口播参数与商品页标注不一致。" },
      { time: "20:18", text: "场控在提词器上发出提醒，主播未即时修正。" },
      { time: "20:35", text: "弹幕开始集中反馈「参数对不上」。" },
      { time: "21:50", text: "商家在后台群提出异议，要求补充说明。" },
      { time: "22:40", text: "直播提前结束，团队发布第一版说明。" },
    ],
    dialogues: [
      { speaker: "场控", side: "left", text: "提词器红了，参数写错了，第二款是另一个版本。" },
      { speaker: "主播", side: "right", text: "我在讲中段，等这段结束再补一句更正可以吗？" },
      { speaker: "商家运营", side: "left", text: "希望尽快更正，我们后台已经在接咨询了。" },
      { speaker: "主播", side: "right", text: "好，我下个环节开头就说，绝对说清楚。" },
      { speaker: "场控", side: "left", text: "已经准备好口播稿，你直接念就行。" },
    ],
    responses: [
      { party: "直播团队", content: "发布说明承认口播失误，承诺对已下单用户开放无理由退款通道。" },
      { party: "品牌方", content: "表示愿配合后续处理，同时希望加强播前对稿环节。" },
      { party: "平台", content: "提示直播间需在显著位置补充更正信息。" },
    ],
    notes: [
      "直播事故的黄金处理窗口极短，超过半小时的沉默往往比失误本身更伤信任。",
      "提词器提醒与主播实时反应的配合，是团队协作的真实考验。",
      "退款通道是否清晰，直接决定舆论从「失误」走向「态度」还是「解决」。",
    ],
  },
  {
    id: "t3",
    slug: "talent-show-communication-record",
    title: "选秀沟通记录整理：节目组与选手的往来信息复原",
    category: "dialogues",
    summary:
      "一份被反复引用的沟通记录，在不同版本里说法并不一致。我们对可以交叉验证的时间节点做了对照，标出三处仍有分歧的地方。",
    date: "2026-08-02",
    readTime: "10 分钟",
    views: "6.2 万",
    tags: ["选秀", "沟通", "记录核对"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20stacked%20paper%20documents%20and%20a%20fountain%20pen%20on%20a%20warm%20cream%20desk%20with%20soft%20window%20light%2C%20muted%20amber%20and%20vermillion%20stationery%20accents%2C%20orderly%20minimal%20composition%2C%20calm%20archival%20mood&width=1200&height=800&seq=hc-cover-03&orientation=landscape",
    hot: false,
    timeline: [
      { time: "初选后第 2 天", text: "节目组发出行程通知，要求确认档期。" },
      { time: "初选后第 4 天", text: "选手方回传档期表，提出需要协调学业安排。" },
      { time: "复赛前 5 天", text: "双方就排练时长进行沟通，出现口径差异。" },
      { time: "复赛当天", text: "现场流程与前期沟通不完全一致。" },
    ],
    dialogues: [
      { speaker: "节目组", side: "left", text: "复赛前需要集中排练三天，能否全程参与？" },
      { speaker: "选手方", side: "right", text: "可以，但第三天下午有安排，能否调到晚上？" },
      { speaker: "节目组", side: "left", text: "我们尽量协调，具体以最终行程表为准。" },
      { speaker: "选手方", side: "right", text: "好的，那我先按这个方案调整。" },
    ],
    responses: [
      { party: "节目组", content: "说明行程以最终发布版本为准，中途调整属正常录制安排。" },
      { party: "选手方", content: "补充说明学业与录制的时间冲突，希望提前获得明确排期。" },
    ],
    notes: [
      "同一段沟通，在不同转述里出现了两处时间顺序差异。",
      "「以最终版本为准」这类表述容易在事后造成理解分歧。",
      "交叉验证时，第三方时间戳比单方截图更有参考价值。",
    ],
  },
  {
    id: "t4",
    slug: "brand-collab-misstep-72h",
    title: "品牌联名翻车复盘：从预热到致歉的 72 小时",
    category: "pr",
    summary:
      "一次本该带来话题度的联名，在预热海报发布后迅速失控。我们按小时拆解品牌方的三次发声，看回应节奏如何决定了舆论的最终落点。",
    date: "2026-07-26",
    readTime: "11 分钟",
    views: "9.1 万",
    tags: ["品牌联名", "公关", "回应节奏"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20a%20retail%20display%20table%20with%20folded%20posters%20and%20a%20manila%20folder%2C%20warm%20cream%20and%20amber%20palette%20with%20subtle%20vermillion%20color%20blocking%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20arrangement%2C%20calm%20professional%20mood&width=1200&height=800&seq=hc-cover-04&orientation=landscape",
    hot: true,
    timeline: [
      { time: "T+0h", text: "预热海报上线，设计元素引发争议。" },
      { time: "T+4h", text: "讨论快速扩散，相关话题进入热榜边缘。" },
      { time: "T+9h", text: "品牌方删除海报，未做任何说明。" },
      { time: "T+30h", text: "发布首份说明，语气被指过于克制。" },
      { time: "T+58h", text: "发布第二份说明，公布具体处理方案。" },
      { time: "T+72h", text: "舆论明显降温，讨论转向行业做法。" },
    ],
    dialogues: [
      { speaker: "内部讨论", side: "left", text: "海报先撤下来，避免继续扩散。" },
      { speaker: "内部讨论", side: "right", text: "只撤不解释，会不会被解读成默认？" },
      { speaker: "内部讨论", side: "left", text: "先把事实核清楚，说明要一次到位。" },
      { speaker: "内部讨论", side: "right", text: "那就把处理方案一起写进去，别再挤牙膏。" },
    ],
    responses: [
      { party: "品牌方", content: "承认前期审核不周，暂停相关物料投放，并公布合作方的后续安排。" },
      { party: "合作方", content: "表示尊重品牌方的处理决定，双方将共同复盘物料审核流程。" },
      { party: "行业观察者", content: "认为争议点在于「删帖与说明之间的空窗期」，而非海报本身。" },
    ],
    notes: [
      "删帖而不说明，往往会被理解为回避，反而延长讨论周期。",
      "第一份说明只讲态度、第二份才给方案，是常见但代价较高的路径。",
      "72 小时是大多数品牌事件的舆论半衰期，回应速度直接影响结果。",
    ],
  },
  {
    id: "t5",
    slug: "fan-club-meeting-minutes",
    title: "粉丝后援会内部纪要：一次应援决策的全部讨论",
    category: "fandom",
    summary:
      "一份流出的小型社群讨论记录，完整呈现了一次应援方案从提议、争论到定稿的过程。我们隐去了所有可识别的个人信息。",
    date: "2026-07-18",
    readTime: "9 分钟",
    views: "5.4 万",
    tags: ["粉丝社群", "应援", "内部讨论"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20colorful%20fabric%20banners%20neatly%20folded%20on%20a%20warm%20cream%20table%20with%20soft%20natural%20light%2C%20muted%20amber%20and%20rose%20accents%2C%20calm%20orderly%20composition%2C%20clean%20minimal%20background%2C%20soft%20editorial%20tone&width=1200&height=800&seq=hc-cover-05&orientation=landscape",
    hot: false,
    timeline: [
      { time: "第 1 天", text: "有人提出集中应援方案，引发初步讨论。" },
      { time: "第 2 天", text: "出现预算分歧，两派意见并未收敛。" },
      { time: "第 3 天", text: "重新拆分方案，改为小额众筹试点。" },
      { time: "第 4 天", text: "定稿并公布执行细则与账单公示方式。" },
    ],
    dialogues: [
      { speaker: "提议者", side: "left", text: "这次想做得更集中一点，效果会更明显。" },
      { speaker: "成员 A", side: "right", text: "预算会不会太高？大家承担能力不一样。" },
      { speaker: "成员 B", side: "right", text: "可以先做小规模试点，看反馈再加码。" },
      { speaker: "提议者", side: "left", text: "那就改成众筹式，账单全程公示。" },
    ],
    responses: [
      { party: "后援会", content: "发布讨论纪要，说明最终采用小额众筹并公开账目。" },
      { party: "参与者", content: "普遍认可公示机制，认为降低了参与门槛。" },
    ],
    notes: [
      "社群决策的难点往往不是热情，而是预算与参与感的平衡。",
      "「先试点再放大」是争议场景里成本最低的推进方式。",
      "账目公示是维持长期信任的关键动作，而非额外负担。",
    ],
  },
  {
    id: "t6",
    slug: "dating-show-editing-timeline",
    title: "恋综剪辑争议：时间线还原与六处疑点",
    category: "opinion",
    summary:
      "观众发现同一场景在两期节目里出现了前后矛盾。我们按镜头与时间戳逐条比对，列出六个值得注意的衔接点。",
    date: "2026-07-11",
    readTime: "13 分钟",
    views: "7.8 万",
    tags: ["恋综", "剪辑", "时间线"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20a%20video%20editing%20timeline%20interface%20on%20a%20monitor%20in%20a%20dim%20warm%20room%2C%20amber%20screen%20glow%20and%20cream%20desk%20surface%2C%20abstract%20geometric%20clip%20blocks%2C%20clean%20minimal%20composition%2C%20calm%20technical%20mood&width=1200&height=800&seq=hc-cover-06&orientation=landscape",
    hot: false,
    timeline: [
      { time: "第 3 期", text: "嘉宾首次提到某次晚餐安排。" },
      { time: "第 5 期", text: "同一场晚餐以不同顺序再次出现。" },
      { time: "第 6 期", text: "观众发现光线与衣着存在不一致。" },
      { time: "第 7 期", text: "节目组未做正面说明，讨论持续。" },
    ],
    dialogues: [
      { speaker: "观众整理帖", side: "left", text: "第 5 期这段的桌面摆位和第 3 期完全不一样。" },
      { speaker: "另一位观众", side: "right", text: "光也变了，第 3 期是白天，这里像傍晚。" },
      { speaker: "观众整理帖", side: "left", text: "所以更像是两段素材拼在一起，不是同一次。" },
      { speaker: "另一位观众", side: "right", text: "先不下结论，等有没有更多角度。" },
    ],
    responses: [
      { party: "节目组", content: "暂未就剪辑顺序公开回应。" },
      { party: "观众群体", content: "分化明显，一部分认为属正常叙事剪辑，一部分希望有说明。" },
    ],
    notes: [
      "观众对时间线的敏感度，正在超过对剧情的敏感度。",
      "「叙事需要」与「事实呈现」之间的界线，是本类争议的常驻话题。",
      "缺乏说明时，讨论会自然滑向对动机的猜测，这通常不是制作方想看到的。",
    ],
  },
  {
    id: "t7",
    slug: "drama-promotion-tide",
    title: "新剧宣发期的舆论走势观察：三天内的情绪曲线",
    category: "opinion",
    summary:
      "一部新剧在开播 72 小时内经历了从「期待」到「争议」再到「回暖」的完整曲线。我们按半天一个节点，记录话题重心的迁移。",
    date: "2026-07-05",
    readTime: "8 分钟",
    views: "4.9 万",
    tags: ["剧集宣发", "舆论", "情绪曲线"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20a%20clapperboard%20and%20a%20rolled%20film%20poster%20on%20a%20warm%20cream%20surface%20with%20soft%20directional%20light%2C%20muted%20amber%20and%20vermillion%20accents%2C%20clean%20minimal%20composition%2C%20calm%20cinematic%20mood%2C%20harmonious%20neutral%20palette&width=1200&height=800&seq=hc-cover-07&orientation=landscape",
    hot: false,
    timeline: [
      { time: "开播前半天", text: "预告片发布，期待值集中释放。" },
      { time: "开播第 6 小时", text: "前两集播出，讨论以角色为主。" },
      { time: "第 1 天晚间", text: "一处剧情设定引发集中讨论。" },
      { time: "第 2 天中午", text: "主创发文解释创作意图。" },
      { time: "第 3 天", text: "讨论回到表演与制作层面，情绪趋稳。" },
    ],
    dialogues: [
      { speaker: "观众 A", side: "left", text: "前两集节奏我想给好评，配角线很有意思。" },
      { speaker: "观众 B", side: "right", text: "但我对第三集那个设定有点出戏。" },
      { speaker: "观众 A", side: "left", text: "等后面解释吧，前面埋线挺明显的。" },
      { speaker: "观众 B", side: "right", text: "行，先追着看，别急着下判断。" },
    ],
    responses: [
      { party: "主创团队", content: "发文说明设定背景，表示后续剧情会给出完整交代。" },
      { party: "平台", content: "补充放出幕后特辑，转移讨论焦点。" },
    ],
    notes: [
      "开播 72 小时基本决定一部剧的口碑基调。",
      "主创主动解释，比沉默更能把讨论拉回作品本身。",
      "情绪曲线往往在第三天自然回落，此时信息密度比声量更重要。",
    ],
  },
  {
    id: "t8",
    slug: "music-festival-cancel-archive",
    title: "音乐节取消风波：公告、回应与后续处理的汇总",
    category: "industry",
    summary:
      "一场音乐节在开幕前 36 小时宣布取消。本文汇总主办方公告原文、乐手回应与观众问题清单，并整理退票与行程处理的完整信息。",
    date: "2026-06-28",
    readTime: "10 分钟",
    views: "6.7 万",
    tags: ["音乐节", "票务", "取消处理"],
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20photograph%20of%20an%20empty%20outdoor%20festival%20stage%20frame%20at%20dusk%20with%20warm%20amber%20lighting%20rigs%20against%20a%20soft%20cream%20sky%2C%20muted%20neutral%20palette%2C%20calm%20minimal%20composition%2C%20soft%20editorial%20tone%2C%20harmonious%20atmosphere&width=1200&height=800&seq=hc-cover-08&orientation=landscape",
    hot: true,
    timeline: [
      { time: "开幕前 3 天", text: "主办方发布天气与场地预警说明。" },
      { time: "开幕前 36 小时", text: "官方公告宣布活动取消。" },
      { time: "公告后 2 小时", text: "退票流程与客服通道同步开放。" },
      { time: "公告后 20 小时", text: "分批公布乐手与供应商的后续安排。" },
      { time: "公告后 48 小时", text: "完成首轮退款，公布补偿方案。" },
    ],
    dialogues: [
      { speaker: "主办方公告", side: "left", text: "受场地条件影响，经综合评估决定取消本次演出。" },
      { speaker: "观众留言", side: "right", text: "行程已经订好了，改签损失能不能一起处理？" },
      { speaker: "主办方公告", side: "left", text: "已开通专线，凭票凭证可申请相关补偿。" },
      { speaker: "观众留言", side: "right", text: "希望补偿细则写得更清楚一点。" },
    ],
    responses: [
      { party: "主办方", content: "公告取消原因，开放自动退款并设立专线处理行程损失。" },
      { party: "参演乐手", content: "表达遗憾，表示会关注后续的补演安排。" },
      { party: "票务平台", content: "同步升级退票指引，缩短到账时间。" },
    ],
    notes: [
      "取消类事件的关键不在公告本身，而在后续处理的颗粒度。",
      "补偿细则越具体，越能减少二次舆情。",
      "退款到账速度，是观众衡量「是否负责任」的直接指标。",
    ],
  },
];

export const faqs = [
  {
    q: "「黑料吃话」的内容主要整理哪些方面？",
    a: "我们围绕娱乐与网络热点展开，主要整理事件时间线、双方对话记录、各方回应和舆论观察笔记，尽量把一件事的完整文字脉络呈现出来，而不是只给结论。",
  },
  {
    q: "网站里的内容可以引用或转载吗？",
    a: "站内的整理结论可以用于个人学习与讨论，引用时请注明来源为「黑料吃话」并附上原文链接。涉及原始素材的部分，请以原始出处为准。",
  },
  {
    q: "文字版和现场视频之间如果有出入怎么办？",
    a: "我们以可交叉验证的时间戳和原始出处为优先。当不同版本存在分歧时，会在观察笔记中标注出来，而不是只保留单一说法。",
  },
  {
    q: "为什么有些事件只有时间线、没有完整对话？",
    a: "部分事件的原始沟通记录并未公开，我们只整理能够核实的信息。缺少的部分会明确说明，不用推测性描述填充。",
  },
  {
    q: "更新频率是怎样的？",
    a: "热点事件通常会在事件发生后的 24 至 72 小时内产出初版整理，随后根据新的公开信息进行两到三次补充修订，修订记录会在文末标注。",
  },
];

export const testimonials = [
  {
    name: "程一鸣",
    role: "内容运营",
    text: "做选题调研的时候，最省时间的就是这种把时间线拉平的文字版。一眼就能看出哪一天的讨论被放大了。",
  },
  {
    name: "林知夏",
    role: "剧集爱好者",
    text: "喜欢它不急着给结论。看完时间线和对话实录，我自己就能判断哪些说法站得住。",
  },
  {
    name: "苏亦然",
    role: "品牌公关从业者",
    text: "复盘别人怎么回应，比看一百篇经验帖都管用。尤其喜欢那种按小时拆解回应节奏的整理。",
  },
];

export const siteStats = [
  { value: "1,280+", label: "已整理档案" },
  { value: "72h", label: "平均更新时效" },
  { value: "36 万", label: "月度读者" },
  { value: "6", label: "内容方向" },
];